export default __webpack_public_path__ + "static/media/alert.cb6f6d7c.svg";